export default "__VITE_ASSET__BMicbPid__"